import { useState, useEffect } from 'react'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { get } from 'lodash';
import { Box, List } from '@mui/material';
import useIrrigationChannels from 'src/hooks/useIrrigationChannels';
import NavItem from './NavItem';
import { setSelectedIrrigation } from 'src/slices/charts';
import { useDispatch } from 'src/store';
import { v4 as uuidv4 } from 'uuid';

const SidebarItems = () => {
  const [menuItem, setMenuItem] = useState<any>()
  const { irrigationChannels } = useIrrigationChannels()
  const dispatch = useDispatch()

  useEffect(() => {
    const menuHome: any = {
      title: "Título",
      items: []
    }
    const menuArray = []
    if (irrigationChannels) {
      dispatch(setSelectedIrrigation(irrigationChannels[0]))
      irrigationChannels.forEach((icn) => {
        menuHome.items.push({
          id: uuidv4(),
          title: icn.name,
        })
      })
    }
    if (menuHome.items.length > 0) {
      menuArray.push(menuHome)
    }
    setMenuItem(menuArray)
  }, [irrigationChannels])

  if (!menuItem) return <></>

  return (
    <Box px={13}>
      <List sx={{ pt: 1 }}>
        {irrigationChannels?.map((irrigation: any) => (
          <NavItem key={"navitem-" + irrigation.irrigation_channel_network_id} irrigation={irrigation} />
        ))}
      </List>
    </Box>
  )
}

export default SidebarItems
